import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { LocStr } from '../utils/Utils';

//= ========================================================================

const TopMenuServices = ({
  globJSON,
  onServiceTabSelected,
  selectedServiceTab,
  language,
  showTopMenuServices,
}) => {
  const renderServicesAllViews = () => globJSON.configurations.services.screens_ordering
    .filter((serviceKey) => globJSON.configurations.services[serviceKey].selected)
    .map((serviceKey, index) => {
      const isSelected = selectedServiceTab === index;
      const myStyles = {
        button: {
          height: 36,
          justifyContent: 'center',
          borderRadius: 18,
          borderWidth: 2,
          borderColor: isSelected ? '#008cff' : '#edf2f7',
          backgroundColor: !isSelected && '#f7fafc',
          flexBasis: '30%',
        },
        text: {
          fontFamily: 'Quicksand-Regular',
          textAlign: 'center',
          color: isSelected && '#008cff',
        },
      };

      return (
        <TouchableOpacity
          style={myStyles.button}
          key={serviceKey}
          onPress={() => {
            onServiceTabSelected(serviceKey);
          }}
        >
          <Text
            numberOfLines={1}
            style={myStyles.text}
          >
            {LocStr(globJSON.configurations.services[serviceKey].name, language)}
          </Text>
        </TouchableOpacity>
      );
    });

  return (
    <View>
      {showTopMenuServices && (
      <View
        style={{
          paddingHorizontal: 50,
          paddingTop: 20,
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        {renderServicesAllViews()}
      </View>
      )}
    </View>

  );
};

export default TopMenuServices;
